exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".player-controls {\n    width: calc(100% - 30px);\n    bottom: 10px;\n    position: absolute;\n}\n\n.player-state {\n    background: black;\n    opacity: 0.5;\n    color: yellow;\n    width: 200px;\n    max-width: 200px;\n}\n\n.player-button {\n    margin: 10px;\n}\n", ""]);

// exports
